module.exports = __webpack_public_path__ + "static/media/pw-wins-icon.cc9a80b7.svg";